import { configureStore } from '@reduxjs/toolkit';

import { channelReducer, sharedReducer } from './reducers';

const store = configureStore({
  reducer: {
    channel: channelReducer,
    shared: sharedReducer
  }
});

export default store;
